import React from 'react';
import PropTypes from 'prop-types';
import Legends from '../Legends';
import { InfoBlock } from '../../../components';

import './LegendIconic.css';

export default class LegendIconic extends Legends {
  static propTypes = {
    amount: PropTypes.num,
    description: PropTypes.string,
    icon: PropTypes.string,
    change: PropTypes.num,
    type: PropTypes.string,
    drop: PropTypes.boolean,
    className: PropTypes.string
  };

  render() {
    return (
      <div className={`LegendIconic ${this.props.className ? this.props.className : ''}`}>
        <div className="img-wrapper">
          <img alt="" className="circle" src={this.props.icon} />
        </div>
        <InfoBlock amount={this.props.amount} description={this.props.description} type={this.props.type} />
        <div className="change-wrapper">
          { this.props.change ? <p className="change" style={{backgroundColor: !this.props.drop ? '#4DAF7C' : '#F47983'}}>
            { this.props.change > 0 ? '+' : '' }{ this.props.change }% Growth { !this.props.drop ? <i className="fa fa-long-arrow-up" aria-hidden="true"></i> : <i className="fa fa-long-arrow-down" aria-hidden="true"></i> }
          </p> : null }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Legends/LegendIconicComponent/LegendIconic.js